<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ReadMoreIndowStories from '$lib/PageSections/ReadMoreIndowStories/ReadMoreIndowStories.svelte';

	import closeUp from './images/close-up.jpg';
	import closeUp2 from './images/close-up2.jpg';
	import inslallingWindows from './images/inslalling-windows.jpg';
	import interiorView from './images/interior-view.jpg';
	import windowPrivacyIdeas from './images/window-privacy-ideas.jpg';
</script>

<Section>
	<p>
		Eric spent 25 years traveling and living in large cities. So, when he moved
		back home to Cincinnati, he wanted to be downtown, close to everything, and
		not in a <em>typical</em> condo. He ended up in the former Fourth National Bank
		Building, built in 1905. It had everything he wanted: space, a modern look, gorgeous
		views of the city…and hotel guests?
	</p>
	<p>
		Eric's large 9 x 4 foot windows looked directly into a hotel across an
		alley. He knew he had to get some kind of window privacy covering—daily
		shared glances with hotel guests? no thanks!—but he didn't want to feel like
		he was living in a cave. He needed window privacy ideas, and soon!
	</p>
	<Image
		src={windowPrivacyIdeas}
		class="no-bleed"
		alt="exterior view of condo with Indow inserts used for window privacy covering"
	/>
	<p>
		He had a special case. He didn't want to replace his large windows (and he
		wasn't sure he could remove the historic windows). He also didn't want to
		cover his windows with something that would leave him in the dark with no
		natural lighting.
	</p>
	<Bubble backgroundColor="grey-light" class="mb-10">
		{#snippet titleSlot()}
			<p class="text-lg font-bold text-indow-grey-dark! uppercase">
				Window Privacy Options
			</p>
		{/snippet}
		<ul>
			<li><p>Blinds (don't let light through)</p></li>
			<li><p>Shade or Curtains (don't let light through)</p></li>
			<li><p>Window Film (can hurt certain types of windows)</p></li>
			<li>
				<p>
					Replacing windows with textured glass (expensive & not possible for
					renters)
				</p>
			</li>
			<li>
				<p>
					Window Inserts (work with existing windows, not permanent, let light
					in)
				</p>
			</li>
		</ul>
	</Bubble>
	<p>
		He found Indow <a href="/products/privacy-inserts">Privacy Grade</a> inserts,
		made from translucent white acrylic, which allows in light while blocking out
		details or defined shadows. They obscure what's happening right outside so you
		maintain your privacy, but you still get plenty of light.
	</p>
	<Image
		src={inslallingWindows}
		class="no-bleed"
		alt="dealers installing Indow inserts for window privacy options"
	/>
	<p>
		The old bank building has drafty windows too, so he decided to buy inserts
		for the rest of the condo for added comfort and energy efficiency. He
		removed them for a short time not long after installation and was surprised
		at the amount of city soot trapped between the window and the Indow insert.
		These fine particles lining the window frame would have otherwise dusted his
		home.
	</p>
	<p>
		"I couldn't believe how much dirt was coming into my unit – a lot of
		pollution from cars and trucks," he said. "I'm guessing I was breathing it
		and it was going through my ventilation system."
	</p>
</Section>

<Section backgroundColor="grey-light">
	<h2>Testimonials</h2>
	<Image
		src={interiorView}
		class="no-bleed"
		alt="interior view of condo with Indow inserts, a window privacy coveringinter"
	/>
	<p class="text-indow-blue! italic">
		"I love the Indow window privacy grade insert," he said. "It's sleek and
		modern. I didn't want to seal the windows off – this allows light into the
		unit."
	</p>
	<p>– Eric Schwartz, Home Owner, Cincinnati, Ohio</p>
	<a href="/resources/case-studies">Read more case studies.</a>
</Section>

<Section>
	<Image
		src={closeUp}
		class="no-bleed"
		alt="closeup of window inside condo with Indow - a window privacy covering"
	/>
	<p>
		He had researched a lot of window privacy ideas including new windows, but
		those would have been prohibitively expensive in his historic building. He
		concluded, "Indow inserts are a great solution."
	</p>
	<p>
		It can be difficult to find the right window privacy covering. Blinds can be
		too dark and curtains can reveal too much. Indow Privacy Grade inserts
		obscure the view, but let in light while also adding insulation, noise
		reduction, and energy savings. Every situation is unique, see if <a
			href="/products/privacy-inserts"
		>
			Indow Privacy Grade Inserts
		</a> will work for you.
	</p>
	<Image
		src={closeUp2}
		class="no-bleed"
		alt="closeup of Indow window insert - a window privacy covering"
	/>
</Section>

<ReadMoreIndowStories />

<GetAFreeEstimate />
